module.exports = __webpack_public_path__ + "static/media/pokemon_information.8c3788eb.svg";